import { render, staticRenderFns } from "./ChatbotIndividualDocuments.vue?vue&type=template&id=5b543856&scoped=true"
import script from "./ChatbotIndividualDocuments.vue?vue&type=script&lang=js"
export * from "./ChatbotIndividualDocuments.vue?vue&type=script&lang=js"
import style0 from "./ChatbotIndividualDocuments.vue?vue&type=style&index=0&id=5b543856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b543856",
  null
  
)

export default component.exports